import RecentWorks from "../Components/RecentWorks";
const Home = (props) => {
  return (
    <div className={`${props.mode}`}>
      <section className="ptb-5 text-center">
        <h1>Hi, I’m Nikita Mallya</h1>
        <h5 className="pt-3">
          An UX/UI Designer with hands-on UI implementation skills, with 6 years
          of experience currently at Ernst &amp; Young (EY), India.
        </h5>
        {/* <div className="doubleBtn">
          <BtnRight
            label="Case Studies & Prototypes"
            className="primary-button"
            to="/works"
          />
          <BtnRight
            label="More About Myself"
            className="secondary-button"
            to="/about"
          />
        </div> */}

        <RecentWorks />
      </section>
    </div>
  );
};

export default Home;
